import React from "react"
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";


const FirstPageReceiptPaymentEntry = (props) => {
    return (
        <>
            {/* 1. Item Search  */}
            <div className="item-search">
                <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                    <div className="search-grp w-[60%]">
                        <label>Party Name</label>
                        <input
                            type="text"
                            id="search"
                            name="search"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.filterDetails.search}
                            onChange={(event) =>
                                props.handleChange(event, "search", "filterDetails")
                            }
                        />
                    </div>

                    <div className="search-grp w-[40%]">
                        <label>Arranged By</label>
                        <select
                            name="arrangedBy"
                            className="w-full"
                            value={props.filterDetails.arrangedBy && props.filterDetails.arrangedBy !== 'Select' && props.arrangedByList.find(
                                (party) => party.value === props.filterDetails.arrangedBy
                            ).value}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "arrangedBy",
                                    "filterDetails"
                                )
                            }
                        >
                            <option>Select</option>
                            {props.arrangedByList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.arrangedBy}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                <button className="add-btn" onClick={props.getVoucherNo}>
                    Add New
                </button>
            </div>

            {/* 2. Item tabel  */}
            <div className="itemList-table">
                <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                    <table className="itemList">
                        <thead>
                            <tr>
                                <td className='w-[15%]'>Voucher No.</td>
                                <td className='w-[15%]'>Date</td>
                                <td className='w-[25%]'>Party Name</td>
                                <td className='w-[15%]'>Cheque No.</td>
                                <td className='w-[15%]'>Amount</td>
                                <td className="w-[15%]" style={{ textAlign: "center" }}>Action</td>
                            </tr>
                        </thead>

                        <tbody>
                            {props.receiptEntryList && props.receiptEntryList.length > 0 ? (
                                props.receiptEntryList.map((item, key) => (
                                    <tr key={key}>
                                        <td>{item.voucherNo}</td>
                                        <td>{moment(item.date).format('DD MMM yyyy')}</td>
                                        <td>{item.partyName}</td>
                                        <td>{item.chqNo}</td>
                                        <td>{props.pageName === 'receiptEntry' ? Number(item.creditAmount).toFixed(2) : Number(item.debitAmount).toFixed(2)}</td>
                                        <td className="!text-center">
                                            <button
                                                className="search-btn"
                                                onClick={() => props.getReceiptDetailsByReceiptId(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faPen} />
                                            </button>
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteReceiptDetailsByReceiptId(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : props.receiptEntryList
                                && props.receiptEntryList.length === 0
                                && props.tableStatus !== "" ? (
                                <tr>
                                    <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                                        {props.tableStatus}
                                    </td>
                                </tr>
                            ) : props.receiptEntryList
                                && props.receiptEntryList.length === 0
                                && props.tableStatus === "" ? null : ""}
                        </tbody>

                    </table>
                </div>
            </div>
        </>
    );
};

export default FirstPageReceiptPaymentEntry;